'use client';

import { useRef, useEffect } from 'react';

interface Slide {
  thumbnail_url?: string;
  job_media_thumbnail_url?: string;
  url?: string;
  attachment_local_url?: string;
  media_type?: string;
  media_uuid: string;
}

interface ThumbnailCarouselProps {
  slides: Slide[];
  activeImage: number;
  onThumbnailClick: (index: number) => void;
}

const ThumbnailCarousel = ({ slides, activeImage, onThumbnailClick }: ThumbnailCarouselProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scrollToThumbnail = (index: number) => {
    const container = scrollContainerRef.current;
    const thumbnail = container?.children[index] as HTMLElement | undefined;
    if (thumbnail && container) {
      const scrollLeft = thumbnail
        .offsetLeft - (container.clientWidth / 2) + (thumbnail.clientWidth / 2);
      container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing pattern
  useEffect(() => {
    scrollToThumbnail(activeImage);
  }, [activeImage]);

  return (
    <div
      className="image-gallery-thumbnail-wrapper"
      ref={scrollContainerRef}
    >
      {slides.map((slide, index) => {
        const thumbnailUrl = slide?.thumbnail_url || slide?.job_media_thumbnail_url || slide?.url
        || slide?.attachment_local_url;

        return (
          <div
            className={`image-gallery-thumbnail-item ${
              index === activeImage ? 'is-selected' : ''
            } ${slide.media_type === 'video' ? 'video' : ''}`}
            key={slide.media_uuid}
            role="button"
            tabIndex={0}
            onClick={() => onThumbnailClick(index)}
          >
            <img
              src={thumbnailUrl}
              alt={`Thumbnail ${index + 1}`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ThumbnailCarousel;
